import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a860d58c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "is-size-3 has-text-centered has-text-white mb-4 pb-4 has-text-weight-semibold" }, "Ranking List", -1))
const _hoisted_2 = { class: "overflow-x-auto max-w-6xl margin-auto" }
const _hoisted_3 = { class: "is-inline-block is-min-full overflow-hidden" }
const _hoisted_4 = { class: "table is-fullwidth is-hoverable is-striped" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { colspan: "4" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "is-size-5" }, "Top Holders in the CNS Community")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Rank"),
    /*#__PURE__*/_createElementVNode("th", null, "Holder"),
    /*#__PURE__*/_createElementVNode("th", { class: "is-hidden-mobile" }, "Binding Address"),
    /*#__PURE__*/_createElementVNode("th", null, "Balance")
  ])
], -1))
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["href"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "mb-1" }
const _hoisted_14 = ["href"]
const _hoisted_15 = { class: "is-hidden-mobile" }
const _hoisted_16 = ["data-tooltip"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-content-copy" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { colspan: "4" }
const _hoisted_21 = { class: "has-background-white" }
const _hoisted_22 = {
  class: "pagination is-right my-2",
  role: "navigation",
  "aria-label": "pagination"
}
const _hoisted_23 = { class: "pagination-list px-0" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-chevron-double-left" }, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-chevron-double-right" }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentHolders, (holder, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: "is-clickable",
                onClick: ($event: any) => (holder.showAllNames = !holder.showAllNames)
              }, [
                _createElementVNode("td", null, _toDisplayString(10 * (_ctx.currentTopHolderPage - 1) + index + 1), 1),
                _createElementVNode("td", null, [
                  (holder.names.split(',').length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(holder.names.split(',').slice(0, 1), (name) => {
                          return (_openBlock(), _createElementBlock("p", {
                            class: "mb-1",
                            key: name
                          }, [
                            _createElementVNode("a", {
                              href: `https://${name.toLocaleLowerCase()}.cool`,
                              target: "_blank",
                              class: "has-text-color-cns"
                            }, _toDisplayString(name), 9, _hoisted_8),
                            _createElementVNode("i", {
                              class: "is-pulled-right mdi mdi-chevron-down is-clickable",
                              "aria-hidden": "true",
                              onClick: _withModifiers(($event: any) => (holder.showAllNames = !holder.showAllNames), ["stop"])
                            }, null, 8, _hoisted_9)
                          ]))
                        }), 128)),
                        (holder.showAllNames)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(holder.names.split(',').slice(1), (name) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  class: "mb-1",
                                  key: name
                                }, [
                                  _createElementVNode("a", {
                                    href: `https://${name.toLocaleLowerCase()}.cool`,
                                    target: "_blank",
                                    class: "has-text-color-cns"
                                  }, _toDisplayString(name), 9, _hoisted_11)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("p", _hoisted_13, [
                          _createElementVNode("a", {
                            href: `https://${holder.names.toLocaleLowerCase()}.cool`,
                            target: "_blank",
                            class: "has-text-color-cns"
                          }, _toDisplayString(holder.names), 9, _hoisted_14)
                        ])
                      ]))
                ]),
                _createElementVNode("td", _hoisted_15, [
                  _createElementVNode("span", {
                    "data-tooltip": _ctx.getAddressFromPuzzleHash(holder.puzzle_hash),
                    class: "mr-2"
                  }, _toDisplayString(_ctx.shorten(_ctx.getAddressFromPuzzleHash(holder.puzzle_hash))), 9, _hoisted_16),
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    onClick: _withModifiers(($event: any) => (_ctx.copy(_ctx.getAddressFromPuzzleHash(holder.puzzle_hash))), ["stop"])
                  }, _hoisted_19, 8, _hoisted_17)
                ]),
                _createElementVNode("td", null, _toDisplayString((Number(holder.balance) / 1000000000000).toFixed(2)) + " XCH", 1)
              ], 8, _hoisted_6))
            }), 128))
          ]),
          _createElementVNode("tfoot", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("nav", _hoisted_22, [
                    _createElementVNode("ul", _hoisted_23, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: _normalizeClass({ 'pagination-link': true, 'is-hidden-mobile': true, 'is-disabled': _ctx.currentTopHolderPage == 1 }),
                          title: "This is the first page",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentTopHolderPage = 1))
                        }, "First", 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: _normalizeClass({ 'pagination-link': true, 'is-disabled': _ctx.currentTopHolderPage == 1 }),
                          title: "This is the first page",
                          onClick: _cache[1] || (_cache[1] = 
                            () => {
                              if (_ctx.currentTopHolderPage > 1) _ctx.currentTopHolderPage -= 1;
                            }
                          )
                        }, _hoisted_25, 2)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.totalPage, (page) => {
                        return (_openBlock(), _createElementBlock("li", { key: page }, [
                          _createElementVNode("a", {
                            class: _normalizeClass({ 'pagination-link': true, 'is-cns': _ctx.currentTopHolderPage == page }),
                            onClick: ($event: any) => (_ctx.currentTopHolderPage = page)
                          }, _toDisplayString(page), 11, _hoisted_26)
                        ]))
                      }), 128)),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: _normalizeClass({ 'pagination-link': true, 'is-disabled': _ctx.currentTopHolderPage == _ctx.totalPage }),
                          onClick: _cache[2] || (_cache[2] = 
                            () => {
                              if (_ctx.currentTopHolderPage < _ctx.totalPage) _ctx.currentTopHolderPage += 1;
                            }
                          )
                        }, _hoisted_28, 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          class: _normalizeClass({
                            'pagination-next': true,
                            'is-hidden-mobile': true,
                            'is-disabled': _ctx.currentTopHolderPage == _ctx.totalPage,
                          }),
                          title: "This is the first page",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.currentTopHolderPage = _ctx.totalPage))
                        }, "Last", 2)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}